import React from "react";
import "./PoliciesStyling.css";
import logo from "../../logo.png";
import { useNavigate } from "react-router-dom";

const AIUseAndContentPolicy = () => {
  const navigate = useNavigate();

  return (
    <main className="policy-page">
      <header className="policy-topbar">
        <button
          className="policy-back-btn"
          onClick={() => navigate(-1)}
          type="button"
        >
          Back
        </button>

        <div className="policy-brand">
          <img src={logo} alt="Kairos" className="policy-logo" />
          <span className="policy-brand-name">Kairos</span>
        </div>
      </header>

      <section className="policy-glass">
        <h1 className="policy-title">AI Use & Content Policy</h1>
        <p className="policy-updated">Last updated: February 5, 2026</p>

        <div className="policy-section">
          <h2>1. Purpose</h2>
          <p>
            This policy explains how you may use Kairos AI features and what content is prohibited.
            It applies to prompts, generated outputs, edits, publishing, and any AI-assisted workflows.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Your responsibility</h2>
          <ul>
            <li>
              You are responsible for reviewing AI outputs before publishing (accuracy, legality, compliance).
            </li>
            <li>
              AI-generated content may be incorrect, incomplete, or outdated; do not rely on it as professional advice.
            </li>
            <li>
              Ensure you have rights to use any text, images, brand names, or assets you provide or publish.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Prohibited content and misuse</h2>
          <ul>
            <li>Illegal activity, fraud, scams, phishing, or deceptive behavior.</li>
            <li>Harassment, hate, threats, or content that promotes violence.</li>
            <li>Malware, hacking instructions, credential theft, or bypassing security safeguards.</li>
            <li>Copyright infringement or unauthorized use of third-party intellectual property.</li>
            <li>Generating or publishing content that violates applicable laws or regulations.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Sensitive data and privacy</h2>
          <ul>
            <li>
              Do not include highly sensitive personal data in prompts unless you have a lawful basis and user consent.
            </li>
            <li>
              If you collect user data on sites you publish, you are responsible for compliance with privacy laws
              and providing required disclosures.
            </li>
            <li>
              Avoid uploading confidential information (trade secrets, private keys, internal credentials).
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Publishing and hosting rules</h2>
          <ul>
            <li>Do not publish sites that distribute spam, malware, or deceptive content.</li>
            <li>
              We may restrict, suspend, or remove published sites that violate this policy or our Terms.
            </li>
            <li>
              You are responsible for your customers’ content and any third-party integrations you enable.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Enforcement</h2>
          <p>
            Violations may result in content removal, feature restrictions, account suspension, or termination.
            We may also cooperate with law enforcement if required.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Contact</h2>
          <p>
            Questions or reports regarding AI use and content should be sent to{" "}
            <strong>support@yourdomain.com</strong>.
          </p>
        </div>
      </section>

      <footer className="policy-footer">
        <p>© 2026 Kairos AI. All rights reserved.</p>
      </footer>
    </main>
  );
};

export default AIUseAndContentPolicy;
